module.exports = "<div class=\"chart-container\">\n</div>\n"